<template>
    <div class="grid
                grid-cols-1
                gap-4"
         :class="hasFamilyPlus ? 'desktop:grid-cols-2': 'desktop:grid-cols-1'">
        <Package v-bind="packages.varietyPlus"
                 :is-selected="isPackageSelected(packages.varietyPlus)"
                 @select="$emit('select-package', hasFamilyPlus && isPackageSelected(packages.familyPlus)? [packages.varietyPlus, packages.familyPlus]: packages.varietyPlus)">
            All of the best news, sports, and entertainment from your favorite channels that you love to watch.
            <a  v-if="channelCounts.varietyPlus"
                @click.prevent="$emit('show-channel-lineup')"
                href="#"
                class="font-bold underline"
            >
                Includes {{ channelCounts.varietyPlus }} channels.
            </a>
            <div class="py-4">
                <img
                    :class="hasFamilyPlus ? null: 'desktop:w-1/2 mx-auto'"
                    alt="Channels include USA, HGTV, ESPN, Disney"
                    src="/assets/images/buyflow/variety-plus-channels.png"
                />
            </div>
        </Package>
        <Package v-if="hasFamilyPlus"
                 v-bind="packages.familyPlus"
                 :is-selected="isPackageSelected(packages.familyPlus)"
                 :prereq="!isPackageSelected(packages.varietyPlus)"
                 prereq-text="Variety+ required"
                 @select="$emit('select-package', packages.familyPlus)">
            Get even more for the entire family including channels your kids are sure to love and some of your favorites as well.
            <a  v-if="channelCounts.familyPlus"
                @click.prevent="$emit('show-channel-lineup')"
                href="#"
                class="font-bold underline"
            >
                Includes {{ channelCounts.familyPlus }} channels.
            </a>
            <div class="py-4">
                <img
                    alt="Channels include AHC, Nick Jr, Nat Geo Wild, Sci"
                    src="/assets/images/buyflow/family-plus-channels.png"
                />
            </div>
        </Package>
    </div>
</template>

<script>
    import Package from './package'

    export default {
        name: 'TVPackages',
        components: {
            Package,
        },
        props: {
            tvData: {
                type: Object,
                required: true,
            },
            packages: {
                type: Object,
                required: true,
            },
            isPackageSelected: {
                type: Function,
                required: true,
            },
            channelCounts: {
                type: Object,
                default: () => ({
                    varietyPlus: 0,
                    familyPlus: 0,
                }),
            },
            selectedChannels: {
                type: Array,
                default: () => [],
            },
        },
        computed: {
            hasFamilyPlus() {
                return Boolean(this.packages.familyPlus)
            },
        },
    }
</script>
